import { Icon } from '@chakra-ui/react';

export const ThumbUpIcon = (props: any) => (
  <Icon aria-label="thumb up icon" viewBox="0 0 16 16" {...props}>
    <path
      d="M0.666666667,14 L3.33333333,14 L3.33333333,6 L0.666666667,6 L0.666666667,14 Z M15.3333333,6.66666667 C15.3333333,5.93333333 14.7333333,5.33333333 14,5.33333333 L9.79333333,5.33333333 L10.4266667,2.28666667 L10.4466667,2.07333333 C10.4466667,1.8 10.3333333,1.54666667 10.1533333,1.36666667 L9.44666667,0.666666667 L5.06,5.06 C4.81333333,5.3 4.66666667,5.63333333 4.66666667,6 L4.66666667,12.6666667 C4.66666667,13.4 5.26666667,14 6,14 L12,14 C12.5533333,14 13.0266667,13.6666667 13.2266667,13.1866667 L15.24,8.48666667 C15.3,8.33333333 15.3333333,8.17333333 15.3333333,8 L15.3333333,6.66666667 Z"
      fill="currentColor"
    />
  </Icon>
);
